import { Routes, Route } from 'react-router-dom';
import { MasterPlan } from './components/MasterPlan';
import { Privacy } from './components/Privacy';
import { Footer } from './components/Footer';
import { Terms } from './components/Terms';

function LandingPage() {
  return (
    <div className="min-h-screen bg-gradient-to-r from-blue-900 via-black to-violet-900 flex items-center justify-center p-4 overflow-hidden relative">
      <div className="relative z-10 max-w-4xl mx-auto text-center">
        <div className="backdrop-blur-xl rounded-md bg-white/10 p-12 shadow-2xl border border-white/20">
          <h1 className="text-6xl font-bold text-transparent bg-clip-text bg-white mb-6">
            Sentience
          </h1>
          <p className="text-lg md:text-xl mb-2 text-white/80 max-w-2xl mx-auto">
            Sentience is your digital memory bank and proactive AI clone – living along side you and learning from everything you do. 
          </p>
          <p className="text-lg md:text-xl text-white/80 mb-12 max-w-2xl mx-auto">
            It's owned privately and entirely by you.
          </p>

          {/* Glassmorphic button */}
          <a 
            href="https://positive-barometer-c76.notion.site/1ffd0f25774a8183b113df2191a31357?pvs=105"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-block px-8 py-4 bg-white/10 backdrop-blur-md rounded-md text-white border border-white/30 hover:bg-white/20 hover:border-white/50 transition-all duration-300 focus:outline-none focus:ring-2 focus:ring-white/50 font-medium text-lg"
          >
            Join Waitlist
          </a>

          <p className="text-sm text-white/40 mt-6">
            Join the waitlist to create your own Sentience.
          </p>
        </div>
      </div>

      <div className="absolute bottom-4 left-0 right-0">
        <Footer />
      </div>
    </div>
  );
}

function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/masterplan" element={<MasterPlan />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/terms" element={<Terms />} />
    </Routes>
  );
}

export default App;
